import { GameType } from "./games.model";

export const GameActionType = {
    Coin: 0,
    XP: 1,
    Badge: 2,
    Proficiency: 3,
    Coaching: 4,
    Survey: 5,
    CoinRatio: 6,
    XPRatio: 7,
    Currency: 8,
    CurrencyRatio: 9,
    Custom: 10,
    Gem: 11
} as const;

export interface MetricDetail {
  MetricID: number;
  Name: string;
  Abbrev?: string;
  DefaultMetricDirection?: number;
  ConversionType?: number;
  NumericTypeValue?: number;
};

export interface IHSelectedMetric {
    HSelectedMetricsID: number;
    HistoryID: number;
    MetricID: number;
    LeftNumber: number;
    RightNumber: number;
    ComparerType?: number;
    Position?: number;
    IsQualifier: boolean;
    MetricDetail?: MetricDetail;
}

export interface IHMetricDetail {
    [MetricID: number]: MetricDetail;
};

export interface IHRewards {
    HRewardsID: number;
    HistoryID: number;
    RewardValue: number;
    RewardText: string;
    ActionType: number;
    Position?: number;
}

export interface IHGameRule {
    HistoryID: number;
    RuleID: number;
    RuleName: string;
    RuleLevel: number;
    GameType: GameType;
    StartDate: Date;
    EndDate: Date;
    IntervalType: number;
    IntervalAmount: number;
    GameCategory: number;
    FolderID: number;
    DateAdded: Date;
    AutoJoin: boolean;
    LastUpdate?: Date;
    LastUpdateInSeconds?: number;
}

export type LastDateFormat = 'Days' | 'Day' | 'Less_Than_Day';

export interface IHGameParams extends IHGameRule {
    HistorySelectedMetrics: Array<IHSelectedMetric>;
    HistoryRewards: Array<IHRewards>;
    HMetricDetails: IHMetricDetail;
}

export interface IHGameStandardize extends IHGameParams {
    metricDefinition: IHSelectedMetric;
    qualifierDefinition: IHSelectedMetric;
    Connect3Definition?: Array<IHSelectedMetric>;
    rewards: Array<StandardizeRewards>;
}

export type StandardizeRewards = {
    name: string;
    coins?: number;
    xp?: number;
    gems?: number;
    badges?: number; // how many badges
    customReward?: string;
    customRewardValue?: number;
    position?: number; // if depends a specific metric value
    metricTarget?: IHSelectedMetric;
};

export type MetricValues = {
    RelatedID: number;
    MetricValueID: number;
    MetricID: number;
    MetricValue: number;
    MetricDisplayValue: string;
    metricCompleted?: boolean;
};

export type TeamObj = {
    TeamID: number;
    Team: string;
};

export type HistoricalTeamObj = {
    metricsValues?: MetricValues[];
} & TeamObj;

export type ParticipantObj = {
    calculatedCoins: number;
    calculatedXP: number;
    custom: string;
    customRewardValue?: number;
    metric?: string;
    metricValue?: number;
    qualifier?: string;
    qualifierValue?: number;
    badges?: number[];
    passed: boolean;
    productState?: number;
    isReverted?: boolean;
    paidDate?: Date;
    reversionDate?: Date;
    results: string;
    rank?: number;
    metricsValues?: MetricValues[];
    connect3Metrics?: MetricValues[];
    ruleObject?: any;
    paymentDate?: string;
    participant: {
        LoginID: number;
        CompanyID: number;
        DateJoined: Date;
        LoginName: string;
        PeriodStartDate: Date;
        RelatedGroupID: number;
        RelatedGroupLevel: number;
        RelatedGroupType: number;
        RuleID: number;
        Team: number;
        TeamID: number;
    };
    team?: TeamObj;
};

export type GameTopPerformer = {
    LoginName: string,
    MetricDisplayValue: string;
}

export type ManualResult = {
    shouldCalculateResult: boolean;
    ranking: RankingParticipant[];
};

export type HTournamentInfo = {
    matches?: {
        leftSide: MatchParticipant[];
        rightSide: MatchParticipant[];
    },
    NumberOfRounds?: number,
};

export type MatchParticipant = {
    GroupID: number;
    RoundNumber: number;
    isWinner: number;
    LoginID: number;
};

export type RankingParticipant = {
    RelatedID: number;
    place: number;
};

export type ActionHistory = {
    LoginID?: number;
};

export enum NumericType {
    Currency = 0,
    Number = 1,
    Percent = 2,
    Time = 3
}
export enum TimeType {
    None = 0,
    Second = 1,
    Minute = 2,
    Hour = 3,
    Time = 4
}